<template>
  <v-dialog v-model="editing" width="500">

    <template></template>


    <v-dialog v-model="showMergeDialog" width="500">

      <template></template>
       <select-items-modal
                    v-model="tag_to_merge_into"
                    title="Select Tag to Merge Into"
                    :includeSearch="true"
                    :isSingular="true"
                    :items="tags.filter(tag => tag.id !== tagObject.id)"
                    itemlabel="full_name"
                    itemvalue="id"
                    @input="handleConfirm($event)"
                    @dialog-clicked="showMergeDialog = false"
       />
    </v-dialog>


    <v-dialog v-model="confirmMergeDialog" width="500">

      <template></template>
      <confirm-modal
          v-if="confirmMergeDialog"
          :confirmationText="confirmChangeMessage"
          @dialog-clicked="mergeIntoTag"
      />
    </v-dialog>

    <v-dialog v-model="confirmDeleteDialog" height="200" width="500">

      <template></template>
      <confirm-modal
          v-if="confirmDeleteDialog"
          :confirmationText="confirmChangeMessage"
          @dialog-clicked="deleteItem"
      />
    </v-dialog>
    <v-form ref="form">
      <v-card>
        <v-container>
          <h6 class="text-center py-4 h6">Edit Tag</h6>
          <v-select
              v-if="tagObject.category"
              :items="tagObject.category.choices"
              :value="tagObject.category.value || null"
              item-text="name"
              item-value="id"
              label="Category"
              required
              @change="logChange"
          >
          </v-select>
          <p v-if="!hasCategory" class="error--text">Must select category</p>
          <v-text-field v-model="tagObject.name"/>
          <p v-if="tagObject.name === ''" class="error--text">Must enter name</p>

          <v-checkbox
              v-model="tagObject.is_active"
              :label="`Is Active`"
          ></v-checkbox>

          <v-divider></v-divider>

          <v-spacer></v-spacer>
          <v-row align="end">
            <v-col cols="6">

              <v-btn v-if="!isNewTag" color="error" text @click="showMergeDialog = true">
                Merge
              </v-btn>

              <v-btn v-if="!isNewTag" color="error" text @click="confirmDeleteDialog = true">
                Delete
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn color="error" text @click="$emit('dialog-clicked')">
                Cancel
              </v-btn>
              <v-btn :disabled="hasCategory === false || tagObject.name === ''" color="success"
                     text
                     @click="submitForm">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

import {mapActions, mapMutations, mapState} from 'vuex'
import SelectItemsModal from '../filters/SelectItemsModal.vue'
import ConfirmModal from '../modals/ConfirmModal.vue'

let message = {
  text: '',
  type: 'success',
  alert: true
}

export default {
  components: {SelectItemsModal, ConfirmModal},
  name: 'EditTagModal',
  data() {
    return {
      showMergeDialog: false,
      mergeDialog: false,
      confirmMergeDialog: false,
      tag_to_merge_into: 1,
      confirmDeleteDialog: false
    }
  },
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    tagObject: {
      type: Object,
      default: function () {
        return {
          name: '',
        }
      }
    }
  },
  computed: {
    ...mapState({
      tags: state => state.tags.tags,
      categories: state => state.categories.categories
    }),
    hasCategory() {
      if (!this.tagObject || !this.tagObject.category || !this.tagObject.category.value) {
        return false
      }

      return this.tagObject.category.value != "";
    },
    isNewTag() {
      return this.tagObject.id === null
    },
    tagToMerge() {
      return this.tags.find(tag => tag.id === this.tagObject.id)
    },
    tagToMergeInto() {
      return this.tags.find(tag => tag.id === parseInt(this.tag_to_merge_into))
    },
    confirmChangeMessage() {
      if (this.confirmMergeDialog) {
        return `Are you sure you want to merge ${this.tagToMerge.name}
                into ${this.tagToMergeInto ? this.tagToMergeInto.name : ''}? `
      }

      return 'Are you sure you want to delete this tag. It will be removed from all photos.'

    }
  },
  methods: {
    ...mapActions(['createTag',
      'updateTag', 'mergeTag',
      'deleteTag']),
    ...mapMutations(['setMessage']),
    logChange(e) {
      this.tagObject.category.value = e
    },
    submitForm() {
      let payload = {
        name: this.tagObject.name,
        is_active: this.tagObject.is_active,
        category__id: this.tagObject.category.value
      }

      if (this.isNewTag) {
        this.createTag(payload)
      } else {
        payload['id'] = this.tagObject.id
        this.updateTag(payload)
      }

      this.$emit('dialog-clicked')
    },
    deleteItem(confirmDelete) {
      if (confirmDelete) {
        let payload = {
          id: this.tagObject.id,
        }
        if (this.tagObject.category) {

          this.deleteTag(payload).then(() => {
          })
        } else {
          this.deleteCategory(payload)
        }

      }
      this.$emit('dialog-clicked')
    },
    mergeIntoTag(val) {
      if (val) {
        let payload = {
          id: this.tagObject.id,
          tag_to_merge_into: this.tag_to_merge_into
        }

        this.mergeTag(payload).then(() => {
          message.text = 'Merge Successful'
          this.setMessage(message)
        })

      }
      this.$emit('dialog-clicked')
    },
    handleConfirm(val) {
      this.confirmMergeDialog = true
      this.tag_to_merge_into = val
    }
  }

}
</script>